import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

export type SnackType = 'success' | 'error' | 'info' | 'warning';

@Injectable({
  providedIn: 'root',
})
export class SnackerService {
  private defaultDuration = 3000;

  constructor(private snackBar: MatSnackBar) {}

  private open(message: string, type: SnackType = 'info', action = 'Close', config?: MatSnackBarConfig) {
    const panelClass = ['saas-snackbar', `snack-${type}`];
    const cfg: MatSnackBarConfig = {
      duration: this.defaultDuration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass,
      ...config,
    };
    this.snackBar.open(message, action, cfg);
  }

  success(message: string, action?: string, config?: MatSnackBarConfig) {
    this.open(message, 'success', action ?? 'OK', config);
  }

  error(message: string, action?: string, config?: MatSnackBarConfig) {
    this.open(message, 'error', action ?? 'OK', config);
  }

  info(message: string, action?: string, config?: MatSnackBarConfig) {
    this.open(message, 'info', action ?? 'OK', config);
  }

  warning(message: string, action?: string, config?: MatSnackBarConfig) {
    this.open(message, 'warning', action ?? 'OK', config);
  }

  // Generic open for custom messages
  openRaw(message: string, action?: string, config?: MatSnackBarConfig) {
    this.open(message, 'info', action, config);
  }
}
